export default __webpack_public_path__ + "428ec895c660de97f0e1e3e2515fed54.jpg";